import { IComment, IComments } from '@/types/types';

type CommentWithReplies = IComment & { replies: IComment[] };

export const buildCommentTree = (comments: IComments): IComment[] => {
  const commentMap: { [key: string]: CommentWithReplies } = {};
  const rootComments: IComment[] = [];

  comments.nodes.forEach(comment => {
    const commentWithReplies = comment as CommentWithReplies;
    commentWithReplies.replies = [];
    commentMap[commentWithReplies.id] = commentWithReplies;
  });

  comments.nodes.forEach(comment => {
    const commentWithReplies = commentMap[comment.id];

    if (commentWithReplies.parentId) {
      if (commentMap[commentWithReplies.parentId]) {
        commentMap[commentWithReplies.parentId].replies.push(
          commentWithReplies,
        );
      }
    } else {
      rootComments.push(commentWithReplies);
    }
  });

  return rootComments;
};
